import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from '../../../services/app.service';
import { authenticationEnum } from '../layout/menu-sidebar/menu-sidebar.component';
import { LoginResponse } from 'src/app/data/models/login-response';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  userName: string = "";
  password: string = "";
  signInProgress: boolean = false;
  constructor(
    private appService: AppService,
    private toastr: ToastrService, private router: Router
  ) {
  }

  ngOnInit() {


  }

  login() {
    if (!this.userName || !this.password)
      return;
    this.signInProgress = true;
    this.appService.getUser({
      userName: this.userName,
      password: this.password
    }).subscribe(
      (response: LoginResponse) => {
        this.signInProgress = false;
        if (response) {
          this.appService.login(response);

        } else {
          this.toastr.error('Login failed', 'User Login');
        }
      },
      (error) => {
        this.signInProgress = false;
        if (error.status == 401)
          this.toastr.error(error.error.title, 'User Login');
        else
          this.toastr.error("Login failed", 'User Login');

      }
    );
  }
}
